module.exports = __webpack_public_path__ + "img/thumbnail_AfricanWildDog_m_normal.803fe753.png";